import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import './TotalCss.css'
import './FetchData.css';
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';
import axios from 'axios';

export class FetchDataUserlocalNetSetTable extends Component {
  static displayName = FetchDataUserlocalNetSetTable.name;

  constructor(props) {
    super(props);
    this.state = {
      fetchDataUserlocalNetSetTable: props.fetchDataUserlocalNetSetTable,
      isFetchDataUserlocalNetSetTable: props.isFetchDataUserlocalNetSetTable,
      forecasts: [],
      loading: true,
      modal: false,
      editingItem: null,
      addModal: false,
      localnetname: '',
      scanOptions: {
        tenable_page: false,
      }
    };

    this.openAddModal = this.openAddModal.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.savelocalnetname = this.savelocalnetname.bind(this);
    this.openRegisterModal = this.openRegisterModal.bind(this);
    this.closeRegisterModal = this.closeRegisterModal.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
  }


  openRegisterModal(item) {
    const allChecked = Object.values(item.unitScanSettings || {}).every(val => val === true);

    this.setState({
      modal: true,
      editingItem: item,
      selectedlocalnetname: item.local_net_name,
      selectedunitname: item.local_unit_name,
      local_net_id: item.local_net_id,
      unitScanSettings: item.unitScanSettings ? { ...item.unitScanSettings } : {},
      isAllChecked: allChecked, // 🛠 檢查是否所有單位的掃描設定都是 true
    });
  }


  closeRegisterModal() {
    this.setState({ modal: false });
  }

  openAddModal() {
    this.setState({ addModal: true });
  }

  closeAddModal() {
    this.setState({ addModal: false });
  }
  handleDelete = (local_net_id) => {
    Swal.fire({
      title: '確定要刪除這個區網嗎？',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消'
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append('local_net_id', local_net_id);


        fetch(api_url + '/api/JRCC/DeleteLocalNetId', {
          method: 'POST',
          headers: { "Authorization": localStorage.getItem('accessToken') },
          body: formData
        })
          .then(response => response.json())
          .then(result => {
            if (result.statusCode === 200) {
              Swal.fire('成功', '項目已成功刪除', 'success');

              this.populateWeatherData();
            } else {
              Swal.fire('錯誤', `${result.row}`, 'error');
            }
          })
          .catch(error => {
            console.log('Error fetching JSON:', error);
          });
      }
    })
  }

  handleToggleAllScanSettings = (isChecked) => {
    this.setState((prevState) => {
      const updatedScanSettings = Object.keys(prevState.unitScanSettings).reduce((acc, unitId) => {
        acc[unitId] = isChecked;
        return acc;
      }, {});

      return {
        unitScanSettings: updatedScanSettings, // 更新所有單位的 `tenable_page`
        isAllChecked: isChecked, // 更新全選狀態
      };
    });
  };


  async saveChanges() {
    const {
      selectedlocalnetname,
      selectedunitname,
      local_net_id,
      isAllChecked
    } = this.state;

    const formData = new FormData();
    formData.append("Local_net_id", local_net_id); // ✅ 區網 ID
    formData.append("Local_net_name", selectedlocalnetname); // ✅ 區網名稱
    formData.append("Local_unit_name", selectedunitname); // ✅ 單位名稱（逗號分隔）
    formData.append("Tenable_page", isAllChecked ? "true" : "false"); // ✅ 掃描設定總開關

    try {
      const response = await axios.post(api_url + "/api/JRCC/PostLocalUnitId", formData, {
        headers: {
          Authorization: localStorage.getItem("accessToken"),
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.statusCode === 200) {
        Swal.fire("成功", response.data.row || "資料已更新", "success");
        await this.populateWeatherData(); // 重新載入資料
        this.setState({ modal: false });
      } else {
        Swal.fire("錯誤", response.data.row || "更新失敗", "error");
      }
    } catch (error) {
      console.error("Error updating unit info:", error);
      Swal.fire("錯誤", "無法更新設定", "error");
    }
  }


  handleScanSettingChange = (localNetId, localUnitId, isChecked) => {
    this.setState((prevState) => ({
      forecasts: prevState.forecasts.map((forecast) => {
        if (forecast.local_net_id === localNetId) {
          return {
            ...forecast,
            unitScanSettings: {
              ...forecast.unitScanSettings,
              [localUnitId]: isChecked,
            },
          };
        }
        return forecast;
      }),
    }));

    this.updateScanSetting(localNetId, localUnitId, isChecked);
  };



  updateScanSetting = async (localNetId, localUnitId, isChecked) => {
    const formData = new FormData();
    formData.append("local_net_id", localNetId);
    formData.append("local_unit_id", localUnitId); // 確保是 local_unit_id
    formData.append("tenable_page", isChecked ? "true" : "false");

    try {
      const response = await axios.put(api_url + "/api/JRCC/PutLocalUnitId", formData, {
        headers: {
          Authorization: localStorage.getItem("accessToken"),
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.statusCode === 200) {
        Swal.fire("成功", "掃描設定已更新", "success");
      } else {
        Swal.fire("錯誤", `${response.data.row}`, "error");
      }
    } catch (error) {
      console.error("Error updating scan setting:", error);
      Swal.fire("錯誤", "無法更新掃描設定", "error");
    }
  };




  async savelocalnetname() {
    const formData = new FormData();
    formData.append('local_net_name', this.state.localnetname);
    axios.post(api_url + '/api/JRCC/PostLocalNetId', formData, {
      method: 'POST',
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
        "Content-Type": "multipart/form-data"
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.statusCode === 200) {
          Swal.fire('成功', `${response.data.row}`, 'success');
          this.populateWeatherData();
        } else {
          Swal.fire('錯誤', `${response.data.row}`, 'error');
        }

        this.setState({ addModal: false, localnetname: '' });
      })
  }




  componentDidMount() {
    this.populateWeatherData();
  }


  renderTableHeader() {
    return (
      <thead>
        <tr>
          <th className='nancy_table_width10'>
            <div className="nancy-table-topC">操作</div></th>
          <th className='nancy_table_width10'>
            <div className="nancy-table-top">使用者區網名稱</div></th>
          <th className='nancy_table_width65'>
            <div className="nancy-table-topC">使用者單位名稱</div></th>
          <th className='nancy_table_width15'>
            <div className="nancy-table-topC">掃描設定</div></th>
        </tr>
      </thead>
    );
  }

  renderTableBody(forecasts) {
    console.log(forecasts);

    return (
      <tbody>
        {forecasts.map((forecast) => {
          const unitNames = forecast.local_unit_name.split(','); // 分割單位名稱
          const unitIds = forecast.local_unit_id.split(','); // 分割單位 ID
          const unitMapping = unitNames.map((name, index) => ({ name: name.trim(), id: unitIds[index]?.trim() }));

          return (
            <React.Fragment key={forecast.local_net_id}>
              {unitMapping.map((unit, index) => (
                <tr key={`${forecast.local_net_id}-${unit.id}`}>
                  {index === 0 && (
                    <td rowSpan={unitMapping.length} className="text-center align-middle">
                      <Button type="modify" className="mx-1 d-inline" onClick={() => this.openRegisterModal(forecast)}>編輯</Button>
                      <Button type="delete" className="mx-1 d-inline" onClick={() => this.handleDelete(forecast.local_net_id)}>刪除</Button>
                    </td>
                  )}
                  {index === 0 && <td rowSpan={unitMapping.length} className="text-center align-middle">{forecast.local_net_name}</td>}

                  {/* 顯示單位名稱 */}
                  <td>{unit.name}</td>

                  {/* 綁定對應的 local_unit_id 來處理 tenable_page */}
                  <td className="text-center align-middle">
                    <input
                      type="checkbox"
                      checked={forecast.unitScanSettings && forecast.unitScanSettings[unit.id] === true}
                      onChange={(e) => this.handleScanSettingChange(forecast.local_net_id, unit.id, e.target.checked)}
                    />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          );
        })}
      </tbody>
    );
  }




  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderTableBody(this.state.forecasts);
    return (
      <div className='mt-2'>
        <div style={{ textAlign: 'right' }}>
          <Button color="success" className="mb-2" onClick={this.openAddModal}>新增</Button>
        </div>
        <table id='tablelabel' className='table table-striped table-bordered dt-responsive nowrap vertical-align-center' aria-labelledby="tableLabel">
          {this.renderTableHeader()}
          {contents}
        </table>
        <Modal isOpen={this.state.modal} toggle={this.closeRegisterModal}>
          <ModalHeader toggle={this.closeRegisterModal}>修改資料</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="userName">區網名稱</Label>
              <Input type="text" id="userName" value={this.state.selectedlocalnetname} onChange={e => this.setState({ selectedlocalnetname: e.target.value.trim() })} />
            </FormGroup>
            <FormGroup>
              <Label for="unitname">單位名稱</Label>
              <Input type="textarea" id="unitname" rows="4" value={this.state.selectedunitname} onChange={e => this.setState({ selectedunitname: e.target.value.trim() })} />
            </FormGroup>

            <FormGroup>
              <Label>掃描設定</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={this.state.isAllChecked} // 🛠 改成使用 isAllChecked 來綁定全選狀態
                    onChange={e => this.handleToggleAllScanSettings(e.target.checked)} // ✅ 影響所有單位
                  />{' '}主機掃描（全選/取消）
                </Label>
              </FormGroup>
            </FormGroup>

          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveChanges}>儲存</Button>{' '}
            <Button color="secondary" onClick={this.closeRegisterModal}>取消</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.addModal} toggle={this.closeAddModal}>
          <ModalHeader toggle={this.closeAddModal}>新增區網名稱</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="localnetname">區網名稱</Label>
              <Input type="text" id="localnetname" value={this.state.localnetname} onChange={e => this.setState({ localnetname: e.target.value.trim() })} />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.savelocalnetname}>儲存</Button>
            <Button color="secondary" onClick={this.closeAddModal}>取消</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  async populateWeatherData() {
    const formData = new FormData();
    formData.append("current_user_type", this.props.fetchedData.current_user_type);
    formData.append("local_net_id", this.props.fetchedData.login_user_net_id);

    // 確保 local_unit_id 存在才加入
    if (this.props.fetchedData.local_unit_id) {
      formData.append("local_unit_id", this.props.fetchedData.local_unit_id);
    }

    await fetch(this.props.fetchedData.apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail];
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];

        const combinedRows = rows.reduce((acc, row) => {
          if (!acc[row.local_net_id]) {
            acc[row.local_net_id] = {
              local_net_name: row.local_net_name,
              local_net_id: row.local_net_id,
              local_unit_ids: [row.local_unit_id],
              local_unit_names: [row.local_unit_name],
              unitScanSettings: {
                [row.local_unit_id]: row.tenable_page !== undefined ? row.tenable_page : false
              }, // 為每個 local_unit_id 存 `tenable_page`
            };
          } else {
            acc[row.local_net_id].local_unit_ids.push(row.local_unit_id);
            acc[row.local_net_id].local_unit_names.push(row.local_unit_name);
            acc[row.local_net_id].unitScanSettings[row.local_unit_id] = row.tenable_page !== undefined ? row.tenable_page : false;
          }
          return acc;
        }, {});

        const forecasts = Object.values(combinedRows).map(row => ({
          local_net_name: row.local_net_name,
          local_unit_name: row.local_unit_names.join(","), // 顯示多個 local_unit_name
          local_unit_id: row.local_unit_ids.join(","), // 加入 local_unit_id
          local_net_id: row.local_net_id,
          unitScanSettings: row.unitScanSettings, // 這裡存每個 local_unit_id 的 `tenable_page`
        }));

        this.setState({ forecasts: forecasts, loading: false });
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }



}  